import { Tooltip, styled } from "@mui/material"

const StyledTooltip = styled(Tooltip)(() => ({
    marginTop: 0,
}))

export { StyledTooltip }
